import { Button, List, styled } from '@mui/material';

import breakpoints from '../../../../constants/breakpoints';

export const Footer = styled('footer')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.action.selected,
  display: 'flex',
  padding: 'var(--spacing-small) var(--spacing-medium)',

  [theme.breakpoints.up(breakpoints.tabletS)]: {
    backgroundColor: 'inherit',
    padding: 'var(--spacing-small) 0 0',
  },
}));

export const Navigation = styled('nav')(() => ({
  width: '100%',
}));

export const NavigationList = styled(List)(({ theme }) => ({
  '& .MuiBadge-root': {
    '& .MuiBadge-badge': {
      backgroundColor: 'var(--color-red-600)',
    },
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'var(--spacing-large)',
    minWidth: 'var(--spacing-large)',
  },
  '& .MuiChip-root': {
    borderRadius: 'var(--border-radius-small)',
    color: theme.palette.primary.main,
    fontSize: 'var(--font-sm)',
    fontWeight: 'var(--font-weight-button-label)',
    paddingInline: 'var(--spacing-tiny)',
  },
  alignItems: 'center',
  display: 'flex',
  gap: 'var(--spacing-tiny)',
  justifyContent: 'space-between',
}));

export const SubmitButton = styled(Button)(() => ({
  height: 'fit-content',
}));
